















































































































































































































































































































































import { Component, Vue, Inject, Prop } from "vue-property-decorator";
import type { CityFeature } from "@/@types/route-info/v2/v2.citys";
import type { Excursion } from "@/@types/route-info/v2/v2.citys";

import Metadata from "@/components/app/metadata.vue";
import NoImage from "@/components/app/shared/image/no-image.vue";
import MapOneDot from "@/components/standart/map/map-one-dot.vue";
import SettingsPanel from "@/components/app/shared/btn&dd/settings-panel.vue";
import IconComponent from "@/components/app/shared/icons/icon-component.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    Metadata,
    NoImage,
    IconComponent,
    MapOneDot,
    SettingsPanel,
  },
})
class RouteInfoV2CityModal extends Vue {
  @Prop({ type: Object, default: null }) city!: CityFeature | null;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Inject("cityFolder") cityFolder!: string;

  private getImageByPriority(): { img: string; folder: string } | null {
    if (!this.city || !this.city.properties.src) return null;
    const src = this.city.properties.src;
    const map: Array<{ name: string; folder: string }> = [
      { name: "image", folder: `${this.cityFolder}/image/hd` },
      { name: "background", folder: `${this.cityFolder}/background/hd` },
      { name: "poster", folder: `${this.cityFolder}/poster/hd` },
      {
        name: "vertical_poster",
        folder: `${this.cityFolder}/vertical_poster/hd`,
      },
      {
        name: "horizontal_poster",
        folder: `${this.cityFolder}/horizontal_poster/hd`,
      },
    ];
    for (const item of map) {
      const val = (src as any)[item.name];
      if (val) return { img: val, folder: item.folder };
    }
    return null;
  }

  get citySrc(): string {
    const best = this.getImageByPriority();
    return best ? this.$getRemoteImage(best.img, best.folder) : "";
  }

  get headerStyle() {
    const best = this.getImageByPriority();
    return `background-image: ${
      best ? `url(${this.$getRemoteImage(best.img, best.folder)})` : "none"
    }`;
  }

  get excursionsList(): Excursion[] {
    if (!this.city || !this.city.properties.excursion) return [];
    const exc = this.city.properties.excursion as any;
    if (Array.isArray(exc)) {
      return exc.filter(
        (e: any) => typeof e === "object" && e !== null
      ) as Excursion[];
    }
    if (typeof exc === "object" && exc !== null) {
      return [exc as Excursion];
    }
    return [];
  }

  handleDelete(): void {
    if (this.city && this.city._id) {
      this.$emit("deleteCity", this.city._id);
    }
  }

  handleRestore(): void {
    if (this.city && this.city._id) {
      this.$emit("restoreCity", this.city._id);
    }
  }

  handleForceDelete(): void {
    if (this.city && this.city._id) {
      this.$emit("forceDeleteCity", this.city._id);
    }
  }
}
export default RouteInfoV2CityModal;
